import { Platform } from "@angular/cdk/platform";
import { CommonModule } from "@angular/common";
import { Component, HostListener, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { SwUpdate } from "@angular/service-worker";
import { AlertDialogService } from "../_alert-dialog/alert-dialog.service";

@Component({
  selector: "app-pwa-install",
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <!-- <div *ngIf="showInstallButton" class="install-banner fixed top-0 left-0">
      <button class="btn btn-primary flex-1" (click)="installPwa()">
        <mat-icon>get_app</mat-icon>
        Installer l'application
      </button>
      <button class="btn btn-warn" (click)="closeBanner()">
        <mat-icon>close</mat-icon>
      </button>
    </div> -->
  `,
  styles: [
    `
      .install-banner {
        z-index: 1000;
        width: 100%;
        display: flex;
        button {
          border-radius: 0 !important;
        }
      }
    `,
  ],
})
export class PwaInstallComponent implements OnInit {
  private deferredPrompt: any;
  showInstallButton = false;

  constructor(
    private platform: Platform,
    private swUpdate: SwUpdate,
    private _alert: AlertDialogService
  ) {}

  @HostListener("window:beforeinstallprompt", ["$event"])
  onBeforeInstallPrompt(e: any) {
    // On supprime la condition de plateforme pour tester
    e.preventDefault();
    this.deferredPrompt = e;
    this.showInstallButton = true;
    if (localStorage.getItem("pwa-install") == "false") {
      return;
    }

    this._alert.openDialog(
      "Application",
      {
        message:
          "L'application Equora est disponnible. Voulez-vous l'installer sur votre appareil ?",
      },
      "confirm",
      [
        {
          text: "Installer l'application",
          type: "primary",
          callBack: () => {
            this.installPwa();
          },
        },
        {
          text: "Non",
          callBack: () => {},
        },
        {
          text: "Ne plus afficher ce message",
          type: "warn",
          callBack: () => {
            localStorage.setItem("pwa-install", "false");
          },
        },
      ]
    );
  }

  async installPwa() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;
      if (outcome === "accepted") {
        this.showInstallButton = false;
      }
      this.deferredPrompt = null;
    }
  }

  ngOnInit() {
    // Vérifier si l'app est déjà installée
    const isStandalone = window.matchMedia(
      "(display-mode: standalone)"
    ).matches;
    if (isStandalone) {
      this.showInstallButton = false;
    }

    // ⚡️ Gère la mise à jour automatique
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === "VERSION_READY") {
          this._alert.openConfirm(
            "Une nouvelle version est disponible, souhaitez-vous la mettre à jour ?",
            () => {
              window.location.reload();
            }
          );
        }
      });
    }
  }

  closeBanner() {
    this.showInstallButton = false;
  }
}
